import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(0.85); }
`

export const ConversationStreamListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.large};
  overflow-y: auto;
`

export const ConversationProgressStubStyled = styled.div`
  align-self: flex-start;
  color: ${(props) => props.theme.colors.text.tertiary};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
`

export const ConversationThinkingSparkleStyled = styled.span`
  display: inline-flex;
  animation: ${pulse} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`
